import * as PageInfo from './PageInfo';

export type GqlConnection<T> = {
  edges: {
    cursor: string;
    node: T;
  }[];
  nodes: T[];
  pageInfo: PageInfo.PageInfo;
  /** Only present on connections whose schema type exposes it. */
  totalCount?: number;
};

export const fromGql = <T, V>(connection: Partial<GqlConnection<V>>, nodeDeserializer: (item: V) => T): GqlConnection<T> => ({
  edges: connection.edges?.map(edge => ({
    cursor: edge.cursor,
    node: nodeDeserializer(edge.node),
  })) ?? [],
  nodes: connection.nodes?.map(nodeDeserializer) ?? [],
  pageInfo: PageInfo.fromGql(connection.pageInfo!),
  totalCount: connection.totalCount,
});
